import Cookies from 'js-cookie';

export const clearAuthCookies = () => {
  Cookies.remove('userUuid');
  Cookies.remove('username');
  Cookies.remove('given_name');
  Cookies.remove('family_name');
};

export const setAuthCookies = (data: {
  userUuid?: string;
  username?: string;
  givenName?: string;
  familyName?: string;
}) => {
  const cookieOptions = {
    expires: 7,
    secure: true,
    sameSite: 'Strict' as const,
  };

  if (data.userUuid) {
    Cookies.set('userUuid', data.userUuid, cookieOptions);
  }
  if (data.username) {
    Cookies.set('username', data.username, cookieOptions);
  }
  if (data.givenName) {
    Cookies.set('given_name', data.givenName, cookieOptions);
  }
  if (data.familyName) {
    Cookies.set('family_name', data.familyName, cookieOptions);
  }
};

